module.exports = __webpack_public_path__ + "img/hand-pluska.b455b9dc.png";